<template>
  <div class="stereo-image-pair" :style="isSelected">
    <v-progress-circular v-if="isLoading" class="escalon-absolute-center" indeterminate />
    <div v-else class="stereo-image" :style="firstImage" />
    <span :class="colorClass">{{firstImageEye}}</span>
    <v-progress-circular v-if="isLoading" class="escalon-absolute-center" indeterminate />
    <div v-else class="stereo-image" :style="secondImage" />
    <span class="secondImageSpan" :class="colorClass">{{secondImageEye}}</span>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "StereoPairMainImage",
  props: {
    image1: Object,
    image2: Object
  },
  computed: {
    ...mapGetters(["stereoContext"]),
    inf(){
      return require("../../assets/INF.png");
    },
    firstSrc(){
      if (!this.image1) return "";
      if (this.image1.thumbNotFound) return this.inf;
      return this.image1.imgObjectUrl || this.image1.thumbObjectUrl;
    },
    firstImage() {
      if (this.firstSrc) 
        return { "background-image": "url('" + this.firstSrc + "')" };
      return "";
    },
    secondSrc(){
      if (!this.image2) return "";
      if (this.image2.thumbNotFound) return this.inf;
      return this.image2.imgObjectUrl ||this.image2.thumbObjectUrl;
    },
    secondImage() {
      if (this.secondSrc) 
        return { "background-image": "url('" + this.secondSrc + "')" };
      return "";
    },
    firstImageEye() {
      return this.image1 && this.image1.imgEye || "";
    },
    secondImageEye() {
      return this.image2 && this.image2.imgEye || "";
    },
    isSelected() {
      if (this.stereoContext && this.stereoContext.selectedPair) {
        if (
          this.stereoContext.selectedPair[0] == this.image1 &&
          this.stereoContext.selectedPair[1] == this.image2
        ) {
          return {
            border: "border: 3px solid $color-white;"
          };
        }
      }
      return "";
    },
    isLoading() {
      if (
        this.stereoContext &&
        this.stereoContext.selectedPair &&
        this.image1 &&
        this.image2
      ) {
        return this.image1.thumbIsLoading || this.image2.thumbIsLoading;
      }
      return true;
    }
  }
};
</script>

<style lang="scss" scoped>
.stereo-image-pair ::v-deep {
  border: 1px solid $color-grey;
  margin: 5px;
  position: relative;
  display: inline-block;
  width: 100%;
  height: calc(100vh - 85px);

  span {
    color: $color-blue;
    font-weight: 900;
    font-size: 50px;
    position: absolute;
    left: 10px;
  }

  .secondImageSpan {
    position: absolute;
    left: 49.7vw;
  }

  .v-input {
    position: absolute;
    top: -25px;
    left: -2px;
  }
}

.stereo-image {
  width: 50%;
  height: 100%;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  margin-right: 0px;
  display: inline-block;
  border: solid grey 1px;
}
</style>
